import axiosInstance from '../services/AxiosInstance';

export const getMerchantPayout = (getData) => {
  return axiosInstance.get("payouts/list", {
    params: getData,
  });
};

export const getMerchantPayoutList = (getData) => {
  return axiosInstance.get("payouts/list", {
    params: getData,
  });
};

export const addMerchantPayout = (data) => {
  return axiosInstance.post("payouts/create", data);
};

export const getMerchantPayoutCount = (data) => {
  return axiosInstance.get("payouts/overview", {
    params: data,
  });
};

export const getIndiviudalMerchantPayoutCount = (id, data) => {
  return axiosInstance.get(`payouts/overview-merchant/${id}`, data);
};

export const getLienandDebitCount = (getData) => {
  return axiosInstance.get(`payouts/debit-merchant-list-count`, {
    params: getData,
  });
};

export const getLienandDebitList = (getData) => {
  return axiosInstance.get("payouts/debit-merchant-list", {
    params: getData,
  });
};

export const updateMerchantPayout = (id, data) => {
  return axiosInstance.put(`payouts/update/${id}`, data);
};

export const updateMerchantDebitBalance = (data) => {
  return axiosInstance.post(`payouts/debit-merchant`, data);
};


export const fetchMerchantPayoutById = async (id) => {
    const response = await axiosInstance.get(`payouts/show/${id}`);
    return response.data;
};

export const getMerchantTransactionData = (transactionId) => {
  return axiosInstance.get(`payouts/view/${transactionId}`);
};

export const getMerchantTransactionBankData = (transactionId) => {
  let dataMainData = axiosInstance.get(`payouts/status/${transactionId}`);
  return dataMainData;
};



export const updateMerchantTransactionStatus = (data) => {
  return axiosInstance.post("payouts/update-status", data);
};

export const manualUpdatePayoutStatus = (data) => {
  return axiosInstance.post("payouts/manual-update-status", data);
};
